import React, { useEffect, useState, Fragment } from 'react';
import { useSelector } from 'react-redux';
import { getLang } from '../reducers/lang'; 
import enUs from "../lang/enUS.json"
import esMX from "../lang/esMX.json"
import { IntlProvider } from "react-intl";

export default function Messages ({ children }) {
    const reduxLang = useSelector(getLang);
    const [file, setFile] = useState(enUs);

    useEffect(()=>{
        switch(reduxLang){
            case 'en-US': setFile(enUs); break;
            case 'es-MX': setFile(esMX); break;
            default: setFile(enUs);
        }
    },[reduxLang])

    return <IntlProvider locale={reduxLang} messages={file} defaultLocale="en-US" >
            {children}
        </IntlProvider>
}